// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"deckViewAsDropdown_dropdown__B4UBY"};